import React from 'react';
import "./App.css";
import Logo3D from "./components/Logo3D";
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import HeaderLogo from "./components/headerLogo";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HeaderLogo/>} />
          <Route path="/pds" element={<Logo3D />} />
        </Routes>
      </Router>
    </div>
);
}

export default App;
